import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import "../vendor/vendorList.css";
import ReactDOM from "react-dom";

const StaticPortalDropdown = ({
  placeholder,
  value,
  options = [],
  onSelect,
  textMaxWidth,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
    placement: "bottom",
  });
  const containerRef = useRef(null);

  const updatePosition = useCallback(() => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const menuMaxHeight = 250; // approx max height

      const spaceBelow = windowHeight - rect.bottom;
      const spaceAbove = rect.top;

      if (spaceBelow < menuMaxHeight && spaceAbove > spaceBelow) {
        setMenuPosition({
          top: rect.top,
          left: rect.left,
          width: rect.width,
          placement: "top",
        });
      } else {
        setMenuPosition({
          top: rect.bottom,
          left: rect.left,
          width: rect.width,
          placement: "bottom",
        });
      }
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      updatePosition();
      window.addEventListener("resize", updatePosition);
      window.addEventListener("scroll", updatePosition);
    }
    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition);
    };
  }, [isOpen, updatePosition]);

  const menu = (
    <Dropdown.Menu
      renderOnMount
      show={isOpen}
      style={{
        position: "fixed",
        top:
          menuPosition.placement === "bottom"
            ? `${menuPosition.top + 5}px`
            : "auto",
        bottom:
          menuPosition.placement === "top"
            ? `${window.innerHeight - menuPosition.top + 5}px`
            : "auto",
        left: `${menuPosition.left}px`,
        minWidth: "180px",
        backgroundColor: "white",
        borderRadius: "8px",
        border: "1px solid #EBEBEB",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        zIndex: 10001,
        margin: 0,
        padding: "4px 0",
      }}
    >
      {options.map((option) => {
        const isAct =
          value === option.value ||
          (value && value.value === option.value) ||
          (value && value.label === option.label);
        return (
          <Dropdown.Item
            className="fs-14 fw-500 textcolor"
            key={option.value}
            onClick={() => {
              onSelect(option);
              setIsOpen(false);
            }}
            active={isAct}
            style={{
              backgroundColor: isAct ? "#f0ebff" : "transparent",
              color: isAct ? "#6c5ce7" : "#212129",
            }}
          >
            {option.label}
          </Dropdown.Item>
        );
      })}
    </Dropdown.Menu>
  );

  const getDisplayLabel = () => {
    if (!value) return "Select";
    if (value.label) return value.label;
    if (typeof value === "string") return value;
    const found = options.find((o) => o.value === value);
    return found ? found.label : "Select";
  };

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      <Dropdown show={isOpen} onToggle={setIsOpen}>
        <Dropdown.Toggle
          variant="light"
          id="dropdown-sort"
          className="d-flex align-items-center justify-content-between"
          style={{
            borderRadius: "12px",
            border: "1px solid #EBEBEB",
            padding: "6px 12px",
            backgroundColor: "white",
            width: "100%",
          }}
        >
          <span className="fs-12 fw-400 textGrey">{placeholder} :</span>
          <span className="d-flex align-items-center px-1 gap-2">
            <span className="dropdown-text" style={{ whiteSpace: "nowrap", maxWidth: textMaxWidth || "120px" }}>
              {getDisplayLabel()}
            </span>
            <span className="dropdown-toggle-arrow textPurple">
              <DownArrow />
            </span>
          </span>
        </Dropdown.Toggle>
        {ReactDOM.createPortal(menu, document.body)}
      </Dropdown>
    </div>
  );
};

export default StaticPortalDropdown;
